import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { resetListOrFavoriteSearchTermAtom } from '../..';
import { ResetQsButton } from '../../../../../../../../Components/ResetQsButton';
import { useSetAtom } from 'jotai';

export const BondResetQsButton = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const setSearchTerm = useSetAtom(resetListOrFavoriteSearchTermAtom);
  return (
    <ResetQsButton
      color={ouiStyle.Constants.Colors.inverted}
      backgroundColor={ouiStyle.Constants.Colors.accent}
      borderColor={ouiStyle.Constants.Colors.accent}
      hoverBackgroundColor={ouiStyle.Constants.Colors.accentShaded}
      onReset={setSearchTerm}
    >
      {children}
    </ResetQsButton>
  );
};
